import React, { useCallback } from "react";
import { StyleSheet } from "react-native";
import { styleConstantsV2 } from "~/style/styleConstantsV2";
import { Icon } from "../Icon";
import { Spacer } from "../Spacer";
import { ButtonCircle } from "./ButtonCircle";
import { Pressable } from "./Pressable";
import { BodyText } from "./Text/BodyText";
import { View } from "./View";
import type { PressableState } from "./Pressable";
import type { IconName } from "../Icon";
import type { ViewStyle } from "react-native";

const S = StyleSheet.create({
  container: {
    backgroundColor: styleConstantsV2.colorWhite,
    paddingHorizontal: 16,
    paddingVertical: 18,
    borderRadius: styleConstantsV2.borderRadius8,
  },
});
interface TabButtonProps {
  onPress?: () => void;
  title: string;
  iconName: IconName;
  backgroundColor?: ViewStyle["backgroundColor"];
  pointerEvents?: ViewStyle["pointerEvents"];
}

export const TabButton = ({
  iconName,
  title,
  onPress,
  backgroundColor,
  pointerEvents,
}: TabButtonProps) => {
  const [isPressed, setIsPressed] = React.useState(false);

  const resolveBackgroundColor = useCallback((state: PressableState) => {
    return state.pressed
      ? styleConstantsV2.colorGrey20
      : styleConstantsV2.colorWhite;
  }, []);

  return (
    <Pressable
      onPressIn={() => {
        setIsPressed(true);
      }}
      onPressOut={() => {
        setIsPressed(false);
      }}
      flexDirectionRow
      alignItemsCenter
      style={(state) => {
        return [
          S.container,
          {
            pointerEvents: pointerEvents,
            backgroundColor: backgroundColor
              ? backgroundColor
              : resolveBackgroundColor(state),
          },
        ];
      }}
      onPress={onPress}
    >
      <Icon name={iconName} size={24} color={styleConstantsV2.colorBlack} />
      <Spacer />
      <View flex>
        <BodyText colorBlack sizeExtraLarge weightBold>
          {title}
        </BodyText>
      </View>
      <ButtonCircle
        iconName="chevron-right"
        size="small"
        pointerEvents="none"
        backgroundColor={
          backgroundColor
            ? backgroundColor
            : isPressed
              ? styleConstantsV2.colorGrey20
              : styleConstantsV2.colorWhite
        }
      />
    </Pressable>
  );
};
